import type { StateCreator } from 'zustand';

import type { StoreType } from '.';

export type SurveyTab = 'survey' | 'responses' | 'statistics';

export type SelectedCommentChoice = {
   choiceId: string;
   choiceLabel: string;
   commentId: string | null;
   commentMessage: string;
   questionId: string;
};

export type MainSlice = {
   surveyTab: SurveyTab;
   setSurveyTab: (value: SurveyTab) => void;
   selectedCommentChoice: SelectedCommentChoice | null;
   setSelectedCommentChoice: (choice: SelectedCommentChoice | null) => void;
   isCommentDirty: boolean;
   setIsCommentDirty: (value: boolean) => void;
   isCommentSaving: boolean;
   setIsCommentSaving: (value: boolean) => void;
};

export const mainSlice: StateCreator<StoreType, [], [], MainSlice> = (set) => ({
   surveyTab: 'survey',
   setSurveyTab: (value: SurveyTab) => set({ surveyTab: value }),
   selectedCommentChoice: null,
   setSelectedCommentChoice: (choice: SelectedCommentChoice | null) =>
      set({ selectedCommentChoice: choice }),
   isCommentDirty: false,
   setIsCommentDirty: (value: boolean) => set({ isCommentDirty: value }),
   isCommentSaving: false,
   setIsCommentSaving: (value: boolean) => set({ isCommentSaving: value }),
});
